import { type ExtractPropTypes, computed, type PropType } from 'vue';

import { type RouterActivityType, routerActivityList } from '../../typings/routerActivityType';

export function withRouterActivityProps(defaultValue?: RouterActivityType) {
  return {
    /**
     * Czy aktywować komponent gdy jego przekierowanie kieruje na widok w którym się znajduje.
     */
    routerActivity: {
      type: String as PropType<RouterActivityType>,
      default: defaultValue
    }
  };
}

export function useRouterActivityProps(
  prefix: string,
  props: ExtractPropTypes<ReturnType<typeof withRouterActivityProps>>
) {
  return computed(() => ({
    [`${prefix}--router-activity-${props.routerActivity}`]: props.routerActivity !== undefined
  }));
}

/**
 * Konfiguracja dla storybooka
 */
export const storiesRouterActivityArgs = {
  args: {
    routerActivity: undefined
  },

  argTypes: {
    routerActivity: {
      options: routerActivityList,
      control: { type: 'inline-radio' }
    }
  }
};
